const ROOT = 'VIEW_AGENCY_WORKER';

const actionTypes = {
  LOAD_DATA: `${ROOT}_LOAD_DATA`,
  LOAD_DATA_SUCCESS: `${ROOT}_LOAD_DATA_SUCCESS`,
  LOAD_DATA_ERROR: `${ROOT}_LOAD_DATA_ERROR`,
  LOAD_SHIFTS: `${ROOT}_LOAD_SHIFTS`,
  LOAD_SHIFTS_SUCCESS: `${ROOT}_LOAD_SHIFTS_SUCCESS`,
  LOAD_SHIFTS_ERROR: `${ROOT}_LOAD_SHIFTS_ERROR`,
  LOAD_TENURE_TRACKS: `${ROOT}_LOAD_TENURE_TRACKS`,
  LOAD_TENURE_TRACKS_SUCCESS: `${ROOT}_LOAD_TENURE_TRACKS_SUCCESS`,
  LOAD_TENURE_TRACKS_ERROR: `${ROOT}_LOAD_TENURE_TRACKS_ERROR`,
  LOAD_SHIFT_HISTORY_POSITIONS: `${ROOT}_LOAD_SHIFT_HISTORY_POSITIONS`,
  LOAD_SHIFT_HISTORY_POSITIONS_SUCCESS: `${ROOT}_LOAD_SHIFT_HISTORY_POSITIONS_SUCCESS`,
  LOAD_SHIFT_HISTORY_POSITIONS_ERROR: `${ROOT}_LOAD_SHIFT_HISTORY_POSITIONS_ERROR`,
  LOAD_CHECKLISTS: `${ROOT}_LOAD_CHECKLISTS`,
  LOAD_CHECKLISTS_SUCCESS: `${ROOT}_LOAD_CHECKLISTS_SUCCESS`,
  LOAD_CHECKLISTS_ERROR: `${ROOT}_LOAD_CHECKLISTS_ERROR`,
  LOAD_CHECKLIST_DETAIL: `${ROOT}_LOAD_CHECKLIST_DETAIL`,
  LOAD_CHECKLIST_DETAIL_SUCCESS: `${ROOT}_LOAD_CHECKLIST_DETAIL_SUCCESS`,
  LOAD_CHECKLIST_DETAIL_ERROR: `${ROOT}_LOAD_CHECKLIST_DETAIL_ERROR`,
  CLEAR_STORE: `${ROOT}_CLEAR_STORE`,
} as const;

export default actionTypes;
